export default {
	Delete: 'Supprimer',
	Add: 'Ajouter',
	DownloadCsv: 'Télécharger en CSV',
};
